export default __webpack_public_path__ + "static/media/plain-sticker-M.3e13ca28.png";